import React, { useState } from "react";
import OwButton from "../OwButton/OwButton";
import OwLabel from "../OwLabel/OwLabel";
import { useIntercom } from "react-use-intercom";
import { useAppContextNonNull } from "@contexts/AppContext";

type Props = {
    toggleHelpDock: () => void;
    toggleCreateTicketModal: () => void;
};

export const HelpDock = (props: Props) => {
    const { userModel, supplierModel } = useAppContextNonNull();
    const { boot, shutdown } = useIntercom();

    const [isIntercomOpen, setIsIntercomOpen] = useState(false);

    const closeChat = () => {
        shutdown();
        setIsIntercomOpen(false);
    };

    return (
        <div className={"HelpDock"}>
            <div className="text-end me-3 mt-3">
                <OwButton className={"btn btn-danger"} centerIconClass={"fa fa-times"} fn={props.toggleHelpDock} />
            </div>
            <div className={"p-2 d-flex justify-content-center"}>
                <div className={"me-3"}>
                    <OwButton title={"create_support_ticket"} fn={props.toggleCreateTicketModal} leftIconClass={"fad fa-headset"} />
                </div>

                <div className={"me-3"}>
                    <a
                        className={"pointer btn btn-sm btn-primary"}
                        target={"_blank"}
                        href={"https://www.orderwerks.com/learn"}
                        rel="noreferrer">
                        <OwLabel className={"pointer"} title={"learning_site"} leftIconClass={"fad fa-chalkboard"} />
                    </a>
                </div>

                <div>
                    {!isIntercomOpen && userModel?.intercom_token?.length && (
                        <OwButton
                            title={"chat"}
                            fn={() => {
                                boot({
                                    intercomUserJwt: userModel.intercom_token,
                                    name: userModel.name,
                                    email: userModel.email,
                                    company: {
                                        companyId: supplierModel.guid,
                                        name: supplierModel.name,
                                    },
                                    customAttributes: {
                                        tags: ["Web App"],
                                    },
                                    // companies: [{ name: supplierModel.name, companyId: supplierModel.guid }]
                                });

                                setIsIntercomOpen(true);
                            }}
                            leftIconClass={"fad fa-comments"}
                        />
                    )}
                    {isIntercomOpen && <OwButton title={"close_chat"} fn={closeChat} leftIconClass={"fad fa-times"} />}
                </div>
            </div>
        </div>
    );
};
